/**Sätter titel på sidan, i webbläsaren och rapporterar det till google analytics som en screen_view
 * @param title Titel på sidan
 * @param internalTitle Titel på sidan som rapporteras till analytics om det inte ska vara samma som title (kan vara tydligare med en längre titel än vad som är lämpligt att visa i browsern)
 */

export const setPageTitle = (title: string, internalTitle?: string) => {
  document.title = title == '' ? 'Aveny' : 'Aveny | ' + title;
  try {
    gtag('event', 'screen_view', {
      app_name: 'Nya Aveny',
      screen_name: internalTitle ?? title,
      page_title: internalTitle ?? title,
    });
  } catch (error) {
    // vi vill inte riskera att det stoppar programmet om loggning till google inte funkar
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

/**Logga att användaren har loggat in
 * @param method Inloggningsmethod
 */
export const logLogin = (method: string) => {
  try {
    gtag('event', 'login', {
      method: method,
    });
  } catch (error) {
    // vi vill inte riskera att det stoppar programmet om loggning till google inte funkar
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
